<template>
  <div id="inspire">
    
    <v-navigation-drawer
      v-model="drawer"
     
      :mini-variant="miniVariant"
      width="200"
      app 
      permanent
    >
    <!-- <v-row>
      <v-col>
        <v-img :src="myLogo"></v-img>
      </v-col>
    </v-row> -->
    <v-img class="mt-2 ml-2 mr-2 mb-2" src="/logus.png"></v-img>

      <v-list dense>
        <template v-for="item in items">         
          <v-list-item
            :key="item.path"
            :to="{ name: item.path }"
            link
            :class="item.path.split('.')[0] === $route.name.split('.')[0] ? 'v-list-item--active' : ''"
            v-if="user.permissions[item.module] >= 5"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title >
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      
      app
      color="blue darken-3"
      dark
    >
      <v-app-bar-nav-icon @click.stop="miniVariant = !miniVariant" />
      <v-toolbar-title
        style="width: 150px"
        class="ml-2"
      >
        
      </v-toolbar-title>
      
      <v-spacer />
     
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            color="white"
            outlined
            v-on="on"
            class="text-none"
          >
           <v-icon left>mdi-account</v-icon> {{user.login}}
          </v-btn>
        </template>
        <v-list>

          <v-list-item
            key="logout"
            @click="logout"
          >
            <v-list-item-title >Wyloguj</v-list-item-title>
          </v-list-item>

          <v-list-item
            key="passchange"
            :to="{ name: 'haslo' }"
          >
            <v-list-item-title>Zmień hasło</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>

</template>

<script>
  import { LOGUS_CONFIG } from '../../config'
  //import myLogoPng from "../../img/logo_white.png"
  import {Permissions} from "../../mixins/permissions"

  export default {
    mixins:[
      Permissions
    ],
    props: {
      source: String,
    },
    data: () => ({
      //myLogo:myLogoPng,
      dialog: false,
      drawer: null,
      miniVariant: false,
      items: [
        { icon: 'mdi-monitor-dashboard', text: 'Pulpit', path: 'pulpit',module:'desktop' },
        { icon: 'mdi-clipboard-account-outline', text: 'Dziennik', path: 'dziennik',module:'journal'},
        { icon: 'mdi-calculator', text: 'Rozliczenia', path: 'rozliczenia',module:'settlement'},
        { icon: 'mdi-cash-register', text: 'Kasa', path:'kasa.dokumenty', module:'payment'},
        { icon: 'mdi-chart-bar', text: 'Raporty', path: 'raporty.godziny',module:'report'},
        { icon: 'mdi-file-table-box-multiple-outline', text: 'Słowniki', path: 'slowniki.grupy',module:'dictionary'},
        { icon: 'mdi-cog-outline', text: 'Ustawienia', path: 'ustawienia.placowki',module:'setting'},
      ],
    }),
    watch:{

    },
    computed:{
      user(){
        return this.$store.getters.getUser;
      },
    },
    methods:{
      logout(){
        this.$store.dispatch( 'loadEmptyUser' );
      },
      
    }
  }
</script>
